import { styled } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { Fragment } from 'react';
import { Outlet } from 'react-router-dom';
import { PageHeader } from '~/views/organisms/page.header';
import { PageFooter } from '~/views/organisms/page.footer';

const Main = styled('main')({});

export const AppWrapper = observer(() => {
    return (
        <Fragment>
            <PageHeader />
            <Main>
                <Outlet />
            </Main>
            <PageFooter />
        </Fragment>
    );
});
